/**
 * Translations for SchedulePage (v0.14.0 PR-4) and the small "next thing"
 * card on HomePage that pulls from the same schedule API. The pill / filter
 * keys for chore mode + week-view land alongside the rest of the page in
 * PR-4b; today-view-only keys live here for PR-4a.
 */
const schedule = {
  zh: {
    'schedule.title': '我的日程',
    'schedule.subtitle': '今天的安排都在这里 — 进行中的最显眼',
    'schedule.requestChange': '申请调整',
    'schedule.now': '现在',
    'schedule.empty': '今天没有安排，去玩耍吧～',
    'schedule.filter.chore': '只看家务',
    'schedule.filter.chore.hint': '🧹 家务块已用橙色高亮',
    'schedule.view.today': '📅 今日',
    'schedule.view.week': '🗓️ 本周',
    'schedule.week.today': '今天',
    'schedule.week.empty': '这天没有安排',
    'schedule.week.loading': '本周日程加载中…',
    'schedule.week.weekday.0': '周日',
    'schedule.week.weekday.1': '周一',
    'schedule.week.weekday.2': '周二',
    'schedule.week.weekday.3': '周三',
    'schedule.week.weekday.4': '周四',
    'schedule.week.weekday.5': '周五',
    'schedule.week.weekday.6': '周六',
    'schedule.loading': '加载中…',
    'schedule.error': '日程没加载成功，下拉再试一次',
    'schedule.section.next': '接下来',
    'schedule.section.done': '今天已完成 ({count})',
    'schedule.section.missed': '错过的',
    'schedule.block.reward': '奖励 🪙 {amount}',
    'schedule.block.rewardNone': '没有奖励',
    'schedule.block.remaining': '还剩 {minutes} 分钟',
    'schedule.block.startsIn': '{minutes} 分钟后开始',
    'schedule.block.makeUp': '待会儿补',
    'schedule.block.starting': '正在进入…',
    'schedule.block.completing': '正在确认…',
    'schedule.block.markDone': '完成',
    'schedule.cta.learning': '去学习 →',
    'schedule.cta.chore': '去家务 →',
    'schedule.cta.task': '去任务 →',
    'schedule.cta.pet_care': '去陪宠物 →',
    'schedule.cta.free_play': '开始自由玩 →',
    'schedule.cta.sleep': '准备睡觉 →',
    'schedule.cta.custom': '开始 →',
    'schedule.changeModal.title': '想改一下今天的安排？',
    'schedule.changeModal.hint': '写一句话告诉爸爸妈妈，比如「想把作业换到晚饭后」。',
    'schedule.changeModal.placeholder': '比如：今天可以晚一点写作业吗？',
    'schedule.changeModal.send': '发送',
    'schedule.changeModal.cancel': '取消',
    'schedule.changeModal.sent': '已经发给爸爸妈妈啦 ✨',
    'schedule.changeModal.error': '发送失败，再试一次吧',
    'schedule.pill.free_play': '自由时间',
    'schedule.pill.learning': '学习时间',
    'schedule.pill.task': '任务时间',
    'schedule.pill.chore': '家务时间',
    'schedule.pill.pet_care': '陪宠物时间',
    'schedule.pill.sleep': '休息时间',
    'schedule.pill.custom': '专心时间',
    'schedule.pill.idle': '没有进行中的安排',
    'home.nextThing.title': '📅 下一件事',
    'home.nextThing.now': '现在',
    'home.nextThing.empty': '今天没有更多安排啦 🎉',
    'home.nextThing.allDone': '今天全部完成啦 ✨',
    'home.nextThing.openSchedule': '查看完整日程 →',
  },
  en: {
    'schedule.title': 'My Schedule',
    'schedule.subtitle': "Today's plan — the current block stands out",
    'schedule.requestChange': 'Request change',
    'schedule.now': 'Now',
    'schedule.filter.chore': 'Chores only',
    'schedule.filter.chore.hint': '🧹 Chore blocks highlighted in orange',
    'schedule.view.today': '📅 Today',
    'schedule.view.week': '🗓️ Week',
    'schedule.week.today': 'Today',
    'schedule.week.empty': 'Nothing this day',
    'schedule.week.loading': 'Loading your week…',
    'schedule.week.weekday.0': 'Sun',
    'schedule.week.weekday.1': 'Mon',
    'schedule.week.weekday.2': 'Tue',
    'schedule.week.weekday.3': 'Wed',
    'schedule.week.weekday.4': 'Thu',
    'schedule.week.weekday.5': 'Fri',
    'schedule.week.weekday.6': 'Sat',
    'schedule.empty': 'No plan today — go play!',
    'schedule.loading': 'Loading…',
    'schedule.error': "Couldn't load your schedule. Pull to retry.",
    'schedule.section.next': 'Up next',
    'schedule.section.done': 'Done today ({count})',
    'schedule.section.missed': 'Missed',
    'schedule.block.reward': 'Reward 🪙 {amount}',
    'schedule.block.rewardNone': 'No reward',
    'schedule.block.remaining': '{minutes} min left',
    'schedule.block.startsIn': 'starts in {minutes} min',
    'schedule.block.makeUp': 'Catch up later',
    'schedule.block.starting': 'Starting…',
    'schedule.block.completing': 'Confirming…',
    'schedule.block.markDone': 'Mark done',
    'schedule.cta.learning': 'Go learn →',
    'schedule.cta.chore': 'Do chore →',
    'schedule.cta.task': 'Do task →',
    'schedule.cta.pet_care': 'Care for pet →',
    'schedule.cta.free_play': 'Start free play →',
    'schedule.cta.sleep': 'Wind down →',
    'schedule.cta.custom': 'Start →',
    'schedule.changeModal.title': 'Want to change today’s plan?',
    'schedule.changeModal.hint': 'Write one line for mom/dad, e.g. "move homework to after dinner".',
    'schedule.changeModal.placeholder': 'e.g. Can I do homework later today?',
    'schedule.changeModal.send': 'Send',
    'schedule.changeModal.cancel': 'Cancel',
    'schedule.changeModal.sent': 'Sent to mom/dad ✨',
    'schedule.changeModal.error': 'Send failed. Try again.',
    'schedule.pill.free_play': 'Free time',
    'schedule.pill.learning': 'Learning time',
    'schedule.pill.task': 'Task time',
    'schedule.pill.chore': 'Chore time',
    'schedule.pill.pet_care': 'Pet time',
    'schedule.pill.sleep': 'Rest time',
    'schedule.pill.custom': 'Focus time',
    'schedule.pill.idle': 'Nothing scheduled right now',
    'home.nextThing.title': '📅 Next up',
    'home.nextThing.now': 'Now',
    'home.nextThing.empty': 'Nothing more today 🎉',
    'home.nextThing.allDone': 'All done for today ✨',
    'home.nextThing.openSchedule': 'See full schedule →',
  },
};

export default schedule;
